import type { ReactNode } from "react";

type StaticPageShellProps = {
  children: ReactNode;
  title: string;
};

export default function StaticPageShell({ children, title }: StaticPageShellProps) {
  return (
    <div className="min-h-screen bg-gray-25 py-12">
      <title>{title}</title>
      <div className="mx-auto max-w-4xl px-6">
        <div className="rounded-xl border border-gray-100 bg-white p-8 shadow-sm">{children}</div>
      </div>
    </div>
  );
}
